var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24Sevenoffice = function Svg24Sevenoffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-24sevenoffice)",
    d: "M0 23c0-3.414 2.793-6.207 6.207-6.207h6.207V23zM22.069 3v4.138H17.93v4.138h-4.138v4.138h12.414V3zM6.207 3C2.793 3 0 5.793 0 9.207h6.207v6.207c3.414 0 6.207-2.793 6.207-6.207S9.62 3 6.207 3m16.896 20a3.104 3.104 0 1 0 0-6.207 3.104 3.104 0 0 0 0 6.207"
  })));
};
export default Svg24Sevenoffice;